<template>
    <div>
        <h2 class="uk-modal-title uk-margin-small-bottom"><slot></slot></h2>
        <div v-if="this.filter" class="uk-align-right@m uk-margin-remove-bottom recipients">
            All Filtered Recipients Selected
        </div>
        <div v-else-if="requisition" class="recipients uk-margin-small-bottom">
            <div class="uk-grid">
                <div class="uk-width-1-2">
                    <select class="uk-select" v-model="shiftId">
                        <option v-for="shift in shiftOptions" :value="shift.id" >{{shift.name}}</option>
                    </select>
                </div>
                <div class="uk-width-1-2 uk-text-right uk-text-bottom">
                    {{ ids.length }} Recipients Selected
                </div>
            </div>
        </div>
        <div v-else class="uk-align-right@m uk-margin-remove-bottom recipients">
            {{ ids.length }} Recipients Selected
        </div>
        <div class="uk-clearfix"></div>
        <div style="margin-bottom: 15px;">
            <label for="message-field" class="uk-form-label">Message Title </label>
            <div class="uk-form-controls">
                <input id="name-field" type="text" class="uk-input" name="group_name" v-model="messageName" />
            </div>
        </div>
        <div>
            <label for="message-field" class="uk-form-label header">Compose Message <span class="uk-align-right uk-margin-remove">{{ message.length }}/{{ messageMaxSize }}</span></label>
            <div class="uk-form-controls">
                <textarea id="message-field" class="uk-textarea bottom-border" name="message" v-model="message"></textarea>
            </div>
        </div>
        <div class="uk-margin-medium-bottom"></div>
        <div class="uk-align-right uk-margin-small-bottom">
            <button class="uk-button uk-button-primary" type="button" @click="submitForm"><i class="fas fa-comment fa-flip-horizontal"></i> Send Message</button>
        </div>
        <div class="uk-clearfix"></div>
        <div class="uk-grid uk-grid-medium">
            <div class="uk-form-controls uk-width-3-4@m">
                <input
                    id="pf-search"
                    type="text"
                    name="pf-search"
                    value=""
                    class="uk-input"
                    v-model="queryParts.q"
                    @keydown="checkSearch"
                    placeholder="Enter Search Terms"
                />
            </div>
            <div class="uk-width-1-4@m uk-text-center" style="padding-top: 6px;">
                <label class="uk-button uk-button-link">
                    <input ref="csv_upload" type="file" style="display: none;" @change="uploadContacts" accept=".xls,.csv,.ods" />
                    <i class="fas fa-upload"></i> Upload List
                </label>
            </div>
        </div>
        <div class="data-table uk-margin-small-top">

            <pagination
                :count="pagination.count"
                :page="pagination.page"
                :per_page="per_page"
                v-on:page="goToPage"
                :bottom="false"
            ></pagination>
            <table ref="table" cellspacing="0" cellpadding="0">
                <thead>
                <tr>
					<th>
						X
					</th>
					<th ref="name_column" class="sortable" @click="sortPersons('full_name', $event)">
						Name
						<i class='fa fa-sort-down' v-if="sorting.current == 'full_name'"></i>
					</th>
					<th ref="phone_column" class="sortable" @click="sortPersons('phone', $event)">
						Phone
						<i class='fa fa-sort-down' v-if="sorting.current == 'phone'"></i>
					</th>
					<th ref="rating_column" class="sortable" @click="sortPersons('average_rating', $event)">
						Rating
						<i class='fa fa-sort-down' v-if="sorting.current == 'average_rating'"></i>
					</th>
                </tr>
                </thead>
                <tbody>
                <!-- data rows -->
                <template v-if="!isLoading" v-for="(row,index) in persons">
                    <tr >
                        <td>
                            <input ref="chbox" type="checkbox" class="uk-checkbox" name="person_ids[]" v-model="ids" :value="row.id" />
                        </td>
                        <td>{{ row.full_name }}</td>
                        <td>{{ row.phone }}</td>
                        <td>{{ row.average_rating }}</td>
                    </tr>
                </template>

                <!-- no data is available for table -->
                <tr v-if="isLoading" >
                    <td colspan="1"><img style="width: 18px;" src="/images/spinner2.gif" /> Loading...</td>
                </tr>
                </tbody>
            </table>
            <pagination
                :count="pagination.count"
                :page="pagination.page"
                :per_page="per_page"
                v-on:page="goToPage"
                :bottom="true"
            ></pagination>
        </div>
    </div>
</template>

<script>
import Pagination from '../Table/Pagination.vue';
import Events from '../../events';
export default {
    name: "GeneralMessageForm",
    components:{
        Pagination
    },
    props:{
        personIds:{type: Array, default:function(){return []}},
        requisitionId:{type: Number, default: 0},
        per_page:{
            type: Number,
            default: 30
        },
    },
    data(){
        return {
            ids: [],
            filter: null,
            messageName:"",
            message: "",
            requisition: null,
            messageMaxSize:160,
            displayWarning: false,
            shiftOptions: [
                {
                    id: 0,
                    name: "All Shifts"
                }
            ],
            isLoading: true,
            persons: [],
            allSelected: false,
            //currentSortField: null,
            //currentSortDir: "asc",
            pagination:{
                page:1,
                limit:30,
                count: 0
            },
            // sorting object for table.
            sorting:{
                current: 'full_name',
                direction: 'asc'
            },
			sortingElement: null,
			queryParts: {
				q:"",
				filters: ["name"],
			}
        }
    },

    mounted(){
        this.requestPersons();
		if(this.sortingElement === null){
			this.sortingElement = this.$refs.name_column;
		}
    },

    methods:{
        submitForm(){
            if(this.ids.length > 0){
                axios.post("/api/message/send", {
                    person_ids: this.ids,
                    group_name: this.messageName,
                    message:this.message
                }).then(() => this.showConfirmation());
            } else if (this.filter != null){
                axios.post("/api/message/send", {
                    filter: this.filter,
                    group_name: this.messageName,
                    message:this.message
                }).then(() => this.showConfirmation());
            }

        },
        requestPersons(){
            this.loadPage(1);
        },
        updatePersons(pack){
            if(pack.data.success){
                this.persons = pack.data.data;
            }
            this.isLoading = false;
			setTimeout(() => { //set the sort flags
				this.sortingElement.classList.add("sorting");
				this.sortingElement.classList.add(this.sorting.direction);
			}, 2);

            /*for(let i = 0; i < this.persons.length;++i){
                let person = this.persons[i];
                if(!person.dropped && !person.no_default && person.phone != null && person.phone !== ""){
                    this.ids.push(person.id);
                }
            }*/
        },
        showConfirmation(){
            //UIkit.modal("#"+this.modalId+"_confirm").show();
			Events.fireEvent("message", "Messages sent.");
			Events.fireEvent("reload-messages");
			this.messageName = "";
			this.message = "";
        },
        setSendIds(arr){
            this.ids = arr;
            this.filter = null;
        },
        addSendId(id){
            this.ids.push(id);
            this.filter = null;
        },
        setFilterCriteria(filter){
            this.filter = filter;
            this.ids = [];
        },
        cancel(){
            this.message = "";
        },
        displayDateList(dates){
            if(dates == undefined || dates == null || dates.length == 0){
                return "-";
            }
            let returnString = "";
            for(let i = 0; i < dates.length;++i){
                returnString += "<div>" + dates[i] + "</div>";
            }
            return returnString;
        },
        sortPersons(field, event){
            let el = event.target;
			this.sortingElement = el;
            //reset css classes
            let sortables = this.$el.getElementsByClassName("sortable");
            for(let i = 0; i < sortables.length;++i){
                sortables[i].classList.remove("sorting");
                sortables[i].classList.remove("asc");
                sortables[i].classList.remove("desc");
            }

            if(this.sorting.current == field){
                if(this.sorting.direction == "asc"){
                    this.sorting.direction = "desc";
                } else {
                    this.sorting.direction = "asc";
                }
            } else {
                this.sorting.direction = "asc";
            }

            this.sorting.current = field;
            //actually sort the data
            this.goToPage(1);
        },
        // event listener when user switches pages
        goToPage(page){
            this.loadPage(page);
        },
        loadPage(i){
			this.queryParts.sort =  this.sorting.current;
			this.queryParts.dir = this.sorting.direction;
			this.queryParts.limit = this.pagination.limit;
			this.queryParts.page = i;
			this.isLoading = true;
			if(isNaN(this.queryParts.q)){
				this.queryParts.filters = ["name"];
			} else {
				if(this.queryParts.q.length === 4){
					this.queryParts.filters = ["ssn"];
				}else{
					this.queryParts.filters = ["emp", "ssn", "phone"];
				}
			}
			axios.get("/api/employee/list/", {params: this.queryParts}).then((ax) => this.gotData(ax))
				.catch(error => this.dataFailure(error));
        },
        gotData(dt){
            this.isLoading = false;
            if(dt.data && dt.data.success){
                this.list_rows = dt.data.data;
                if(dt.data.paged){
                    this.pagination.page = dt.data.pagination.page;
                    this.pagination.limit = dt.data.pagination.limit;
                    this.pagination.count = dt.data.pagination.total;
                }
                //this.saveStorage();
            }
            this.updatePersons(dt);
        },
        dataFailure(error){
            this.isLoading = false;
            console.warn("data failed to load.", error);
            if(typeof this.callBackFunction == "function"){
                this.callBackFunction();
            }
        },
        checkSearch(e){
            if(e.keyCode == 13){
                this.loadPage(1);
            }
        },
        uploadContacts(){
            console.log(this.$refs.csv_upload.files);
            if(this.$refs.csv_upload.files.length > 0){
                console.log("By the file of greyskull, I have the file!!!");
                let formData = new FormData();
                formData.append("file", this.$refs.csv_upload.files[0]);
                axios.post("/api/message/contact/upload", formData)
                    .then(
                        (pack) => this.updateContacts(pack),
                        (pack) => this.uploadFailure(pack)
                    );
            }
        },
        updateContacts(pack){
            if(pack.data.success){
                this.ids = pack.data.data.ids;
            } else {
                this.uploadFailure(pack);
            }
        },
        uploadFailure(pack){
            console.log(pack);
            //todo: alert that something went wrong.
        }
    },

    watch:{
        message(){
            if(this.message.length > 160){
                this.message = this.message.substr(0, this.messageMaxSize);
            }
        }
    }
}
</script>

<style scoped>

</style>
